const identifyEnviromentMobile = () => {
    try {
        const {appSignature} =  JSON.parse(navigator.userAgent.substring(navigator.userAgent.indexOf("{"),navigator.userAgent.lastIndexOf("}") + 1))    
        if ( String(appSignature.name).includes("MiEstudio")) {
            return null;
        }
        return true;
    } catch (error) {
        return null;
    }
}

export const postMessageToMobile = (msg) => {
    try {
        window.ReactNativeWebView.postMessage(String(msg)); 
    } catch (error) {
        console.log("Error en postMessageMobile")
    }
}


export default identifyEnviromentMobile;